/**
 * Created by desheng.zhao on 2019/6/17.
 */
import Vue from 'vue';

const errorLog = {
  state: {
    errors: {}
  },
  mutations: {
    addError(state, payload) {

      if(Array.isArray(state.errors[payload.page])){
        // state.errors[payload.page].push(payload.error);
        Vue.set(state.errors, payload.page, state.errors[payload.page].concat(payload.error))
      }else{
        // state.errors[payload.page] = [payload.error];
        Vue.set(state.errors, payload.page, [payload.error])
      }
    }
  },
  actions: {
    addError(state, payload) {
      if(Object.prototype.toString.call(payload.error) !="[object Error]") {
        payload.error = new Error(payload.error)
      }

      payload.error.page = payload.page
      state.commit("addError",payload);
    }
  },
  getters: {
    allError: function(state){
      let errs = [];
      console.log(state)
      const obj = state.errorLog ? state.errorLog.errors : state.errors;
      Object.keys(obj).forEach(item => {
        errs = errs.concat(obj[item]);
      });
      return errs;
    },
    pageError(state){
      return (page) => {
        return state.errors[page];
      }
    },
    hasErrorPages(state){
        const obj = state.errorLog ? state.errorLog.errors : state.errors;
        return Object.keys(obj);
    }
  }
}

export default errorLog;



// WEBPACK FOOTER //
// ./src/store/errorLog.js